import { getTypeValue } from "../../../../helpers/common/searchers/index.js";
// @@@@@@START-NOSCAN@@@@@@
const parseFilters = (filters)=>Object.entries(filters).map(([key, value])=>`${key}=${value}`).join('&');
const PRODUCT = {
    CIU: 3,
    HOT: 3,
    ISL: 2,
    ZON: 2
};
export const getFlightOperative = async (url = '/packagesalexswc/AjaxServices/GetFlightOperative/', { origin , destination  } = {}, { BaseUrl , Application  } = {})=>{
    if (!destination?.value || !destination?.type || !origin?.value || !BaseUrl || !Application) return;
    let finalUrl = url;
    if (!url.startsWith('http')) finalUrl = `${BaseUrl}${url}`;
    const filters = {
        ori: origin.value,
        des_code: getTypeValue(destination).value,
        des_type: PRODUCT[getTypeValue(destination).type],
        date_from: '',
        date_to: '',
        app: Application,
        stops: 0
    };
    if (process.env.NODE_ENV !== 'production') {
        const flightOperativeMockData = await import("./mock.js").then((m)=>m.flightOperativeMockData);
        return flightOperativeMockData;
    }
    const response = await fetch(`${finalUrl}?${parseFilters(filters)}`);
    if (!response.ok) {
        return {
            checkins: [],
            checkouts: []
        };
    }
    const data = await response.json().catch(()=>({
            checkins: [],
            checkouts: []
        }));
    return data;
};
export const getAirportCodeByDestination = async (url = '/packagesalexswc/AjaxServices/GetAirportCodeByDestination/', { destination  } = {}, { BaseUrl  } = {})=>{
    if (!destination?.value || !destination?.type || !BaseUrl) return;
    let finalUrl = url;
    if (!url.startsWith('http')) finalUrl = `${BaseUrl}${url}`;
    const filters = {
        destinationCode: getTypeValue(destination).value,
        destinationType: getTypeValue(destination).type
    };
    if (process.env.NODE_ENV !== 'production') {
        const airportCodeByDestinationMockData = await import("./mock.js").then((m)=>m.airportCodeByDestinationMockData);
        return airportCodeByDestinationMockData;
    }
    const response = await fetch(`${finalUrl}?${parseFilters(filters)}`);
    if (!response.ok) throw new Error('Error getting airport code by destination');
    const data = await response.json().catch(()=>{
        throw new Error('Error parsing airport code by destination');
    });
    return data;
};
export const getApplicableDiscounts = async (url = '/packagesalexswc/AjaxServices/ApplicableDiscounts/', { origin , destination  } = {}, { BaseUrl , Language , Application  } = {})=>{
    if (!origin?.value || !destination?.value || !destination?.type || !BaseUrl || !Language || !Application) return;
    let finalUrl = url;
    if (!url.startsWith('http')) finalUrl = `${BaseUrl}${url}`;
    const filters = {
        ori: origin.value,
        dest: getTypeValue(destination).value,
        type: getTypeValue(destination).type,
        lang: Language.toLowerCase(),
        app: Application
    };
    if (process.env.NODE_ENV !== 'production') {
        const applicableDiscountsMockData = await import("./mock.js").then((m)=>m.applicableDiscountsMockData);
        return applicableDiscountsMockData;
    }
    const response = await fetch(`${finalUrl}?${parseFilters(filters)}`);
    if (!response.ok) throw new Error('Error getting applicable discounts');
    const data = await response.json().catch(()=>{
        throw new Error('Error parsing applicable discounts');
    });
    return data;
}; // @@@@@@END-NOSCAN@@@@@@

//# sourceMappingURL=service.js.map